import { flagFactory } from '../icon';
import Svg from './ro.svg';

export default flagFactory(Svg);
